import { render, staticRenderFns } from "./VPN.vue?vue&type=template&id=738bd802&scoped=true&"
import script from "./VPN.vue?vue&type=script&lang=js&"
export * from "./VPN.vue?vue&type=script&lang=js&"
import style0 from "./VPN.vue?vue&type=style&index=0&id=738bd802&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738bd802",
  null
  
)

export default component.exports